var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bookmarked_bok",class:( _obj = {}, _obj[_vm.curTheme] = true, _obj ),on:{"click":_vm.onClick}},[(!_vm.isBookmarked)?_c('el-tooltip',{attrs:{"content":"Добавить в избранные","placement":"top"}},[_c('button',{staticClass:"bok_btn bok_btn--add"})]):_c('el-tooltip',{attrs:{"content":"Убрать из избранных","placement":"top"}},[_c('button',{staticClass:"bok_btn bok_btn--remove"})])],1)
var _obj;}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d21812a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Bookmarked.vue
// module id = null
// module chunks = 